import { useTranslation } from "react-i18next";
import { Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { DealerDMSICarConfig } from "models";
import type { AddEditDealerFormPayload } from "modules/DMSv3/Settings/components/AddEditDealerModal";

export type ICarConfig = Pick<DealerDMSICarConfig, "dms_dealer_id" | "dms_customer_waiting_id">;

const FormHelper = createFormHelper<AddEditDealerFormPayload>();

export const ICarConfigSection = () => {
  const { t } = useTranslation();

  return (
    <>
      <Grid columns="equal">
        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_dealer_id", "DMS Dealer ID")} </label>
            <FormHelper.Field.Input name="icar_config.dms_dealer_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>

        <GridColumn>
          <Form.Field>
            <label>{t("v8_dms_customer_waiting_id", "DMS Customer waiting ID")} </label>
            <FormHelper.Field.Input name="icar_config.dms_customer_waiting_id" inputProps={{ fluid: true }} />
          </Form.Field>
        </GridColumn>
      </Grid>
    </>
  );
};
